import { Component } from '@angular/core';
import { LicenseService } from '../../core/services/http-services/license.service';
import { ErrorPagesComponent } from './error-pages.component';
import { AppConstants } from '../../app.constants';

@Component({
  styleUrls: ['./error-pages.scss'],
  templateUrl: './error-pages.component.html'
})

export class ForbiddenErrorPageComponent extends ErrorPagesComponent {
  constructor(
    protected readonly licenseService: LicenseService
  ) {
    super(licenseService);
    this.errorCode = 403;
    this.errorTitle = 'Forbidden';
    this.errorDescription = AppConstants.PERMISSION_ERROR_MESSAGE;
  }
}
